// @ts-nocheck
import React, { FC, useEffect, useState, useMemo, memo, useCallback, useRef } from 'react';
import {Nullable, Project, PageModel, API, GetProjectsByFilterProps, Competition} from '@brg/api';
import { useProfile, bProfile } from '@brg/auth';
import { FInter, FlexBox, useIsMobile, useScrollingState } from '@brg/ui';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector, useDispatch } from "react-redux";
import { GridWrapperNew, ProjectsGridNew } from '../../shared/components/grids';
import { useProjectsList } from '../../shared/hooks/api/useProjectsByFilter';
import { Pagination } from '../../shared/components/pagination';
import { useModal } from '../modules';
import useQueryState from "../../shared/hooks/useQueryState";
import { useTranslation } from 'react-i18next';
import { ProgressBar } from 'shared/icons/Progress';
import styled, { useTheme } from 'styled-components';
import { useFastScrolling } from 'shared/hooks/useFastScrolling';
import { AppTester } from "supporting";
import { InfinityProjectsSelector, InfinityProjectsActions } from '../../shared/reducers/InfinityProjects';
import ShowMoreProjectsBlock from 'shared/components/ShowMoreProjectsBlock/ShowMoreProjectsBlock';

import {
  fetchInfiniteProjects,
  fetchInfiniteProjectsMore,
  fetchInfiniteProjectsWithUpdate
} from '../../shared/actions/infinityProjectsActions';
import { EmptyCardsLoading } from 'shared/components/CardsLoading/EmptyCards';
import { SkeletonCard } from 'shared/components/SkeletonCard/SkeletonCard';
import { ONLINES_PROJECT_ORDER_INDEX } from "../../shared/pages/explore/constants";
import { useLocation, useRouteMatch } from "react-router-dom";
import { TOwnerRights } from 'shared/pages/exploreHseContextsNew/exploreHseContextsNew';
import { PRESENTATION_VIEW_TYPES } from 'shared/constants/presentationSign';
import { RingPositions } from 'shared/constants/ringPositionType';
import { EmptyCategory } from 'shared/components/EmptyCategory/EmptyCategory';
import { ProjectCardItem } from './ProjectsButchController/ProjectCardItem';

const PROJECTS_COUNT_FOR_OFFSET = 20;
const PAGE_COUNT_STARTS = 1;
const PAGE_WHICH_UPLOAD_ENDS = 4;
const PAGE_WHICH_UPLOAD_ENDS_MOB = 3;
const NULLABLE_OFFSET = 0;

export const StyledLoading = styled.div`
    margin-bottom: 40px;
    padding: 10px;
    font-size: 60px;
    line-height: 1;
    color: white;
    text-align: center;
`;

export const ShowMoreWrapper = styled(FlexBox)`
  margin-left: auto;
  margin-right: auto;
  border: 1px solid ${p => p.theme.progressbar.borderColor};
  border-radius: 3px;
  padding: 12px 48px;
`;

const OffsetBlock = styled.div<{ display: boolean }>`
  width: 100%;
  margin-top: 64px;
  display: ${p => p?.display ? 'inline-block' : 'none'};
`;

const isFilterChanged = (v: any, k: any, entity: string) => {
  return v && k && v[entity] && (k[entity] === undefined || (k[entity] && v[entity][0] !== k[entity][0]))
}

type Tabs = {
  [key: string]: string[] | string | null;
}

/**
 * @param withOtherProjects - сделать запрос в модалке своих и чужих проектов для папок
 */

export interface ProjectsButchControllerProps<T = Project> {
  filter: GetProjectsByFilterProps;
  date: number;
  onProjectsLoaded?: (projects: T[]) => void;
  setProjectsLoadingExt?: (isLoadiing?: boolean) => void
  selectable?: boolean;
  unselectable?: boolean;
  onSelect?: (projectId: string) => void;
  withoutGoToProject?: boolean;
  noPagging?: boolean;
  selectedProjects?: string[];
  isParticipate?: string[];
  modal?: boolean;
  clearProjects?: () => void,
  setProjectCount?: (count: any) => void,
  linkPrefix?: string;
  isInfinityNeed?: boolean;
  projectsCount?: number;
  isLoading?: Function;
  isSelectRightNeed?:boolean;
  columns?: number;
  isUnload?: boolean;
  preloadedTabs?: Tabs[];
  currentTab?: string;
  contextName?: string;
  isPageWithoutTabs?: boolean;
  disableFilterCheck?: boolean;
  showCompetitionPoint?: boolean;
  showCompetitionJuryPoint?: boolean;
  showFirstCompetitionPoint?: boolean;
  currentCompetitionId?: string;
  isTeamProjects?: boolean;
  withoutQueryParams?: boolean;
  isDisabled?: boolean;
  canMakeImageForTeam?: TOwnerRights;
  externalPageParam?: boolean;
  isMainPage?: boolean;
  metaAlwaysVisible?: boolean;
  itemType?: string;
  noPresentation?: boolean;
  selectRingPosition?: RingPositions;
  isMoreVisible?: boolean;
  withOtherProjects?: boolean;
  useListLiteModal?: boolean;
  withoutRepost?: boolean;
  competition?: Competition<'Local'>;
}

export const ProjectsButchController: FC<ProjectsButchControllerProps> = memo(({
  filter,
  date,
  onProjectsLoaded = () => undefined,
  setProjectsLoadingExt,
  isLoading,
  selectable = false,
  modal = false,
  onSelect = () => undefined,
  withoutGoToProject,
  withOtherProjects,
  noPagging,
  selectedProjects = [],
  isParticipate = [],
  clearProjects,
  setProjectCount,
  withoutRepost,
  projectsCount,
  isMoreVisible,
  linkPrefix,
  isInfinityNeed,
  isSelectRightNeed,
  selectRingPosition,
  unselectable,
  columns,
  isUnload,
  isPageWithoutTabs,
  preloadedTabs,
  contextName,
  currentTab,
  disableFilterCheck,
  showCompetitionPoint,
  showCompetitionJuryPoint,
  showFirstCompetitionPoint,
  currentCompetitionId,
  isTeamProjects,
  canMakeImageForTeam,
  withoutQueryParams,
  externalPageParam,
  noPresentation,
  isMainPage,
  itemType,
  metaAlwaysVisible,
  competition,
  useListLiteModal
}) => {
  const designer = useProfile();
  const theme = useTheme();
  const [{ page: externalPage = 1, teachersOnly },  setExternalQueryParams] = useQueryState();
  const [temp, setTemp] = useState(0);
  const dispatch = useDispatch();
  const [prevStringData, setPrevStringData] = useState('');
  const [filterType, setFilterType] = useState<number>();
  const { show } = useModal();
  const [refresh, setRefresh] = useState<boolean>(false);
  const isAgeyTomesh = AppTester.isAgeytomesh();
  const isOnlines = AppTester.isOnlines();
  const isMobile = useIsMobile();
  const isDafes = AppTester.isGeoDafes();

  const [internalPage, setPage] = useState(1);

  const currentPage = externalPageParam ? externalPage : internalPage;

  const setQueryParams = useCallback(({ page }: any) => {
    if (externalPageParam) {
      setExternalQueryParams({ page }, { replace: true })
    } else {
      setPage(page);
    }
  }, [externalPageParam]);

  const { t, i18n } = useTranslation();

  const infScrollRef = useRef<any>(null);
  const tabRef = useRef<any>(null);
  const scrollTop = () => window.scrollTo(0 , 0);

  const infinityProjects = useSelector(InfinityProjectsSelector)?.data;
  const infinityProjectsPaging = useSelector(InfinityProjectsSelector)?.paging;
  const infinityProjectsFilter= useSelector(InfinityProjectsSelector)?.filter;
  const infinityProjectsPreloadData = useSelector(InfinityProjectsSelector)?.preloadData;
  const infinityProjectsPagingList = useSelector(InfinityProjectsSelector)?.pagingList;
  const isPreloadLoading = useSelector(InfinityProjectsSelector)?.isTabsLoading;
  const isProjectPage = useSelector(InfinityProjectsSelector)?.isProjectPage;
  const infinityProjectsLoading = useSelector(InfinityProjectsSelector)?.isLoading;
  const isFinalPage = useSelector(InfinityProjectsSelector)?.isFinalPage;


  const isStartPage = useMemo(() => (currentPage && Number(currentPage) === PAGE_COUNT_STARTS), [currentPage])
  const isNeedUpdatePreload = useMemo(
    () => ( refresh && Number(currentPage) === PAGE_COUNT_STARTS), [refresh, currentPage]);
  const isNeedUpdMore = useMemo(
    () => ( refresh && Number(currentPage) > PAGE_COUNT_STARTS), [refresh, currentPage])
  const isBackToStartPage = useMemo(() => (refresh && Number(currentPage) === PAGE_COUNT_STARTS), [refresh, currentPage]);

  const infinityProjectsWithPreload = useMemo(() => {
    if (isOnlines) {
      return [...infinityProjects]?.sort((a, b) => {
        if (ONLINES_PROJECT_ORDER_INDEX[a.projectId] > ONLINES_PROJECT_ORDER_INDEX[b.projectId]) {
          return 1;
        }
        if (ONLINES_PROJECT_ORDER_INDEX[a.projectId] < ONLINES_PROJECT_ORDER_INDEX[b.projectId]) {
          return -1;
        }
        return 0;
      });
    }
    if (isPageWithoutTabs || (isPageWithoutTabs && (isNeedUpdMore || isBackToStartPage))) {
      return infinityProjects;
    }
    if (currentTab && !isPreloadLoading) {
      const arr = infinityProjectsPreloadData[currentTab] ? infinityProjectsPreloadData[currentTab] : [];
        if (isStartPage || isNeedUpdatePreload || isBackToStartPage) return arr;
        if (isNeedUpdMore) return infinityProjects;
        else {
          return [...arr, ...infinityProjects]
        }
    }
  }, [
    infinityProjects,
    infinityProjectsPreloadData,
    currentTab,
    isNeedUpdMore,
    // isNeedShowPreload,
    isPreloadLoading,
    isNeedUpdatePreload,
    isStartPage,
    isBackToStartPage,
    isPageWithoutTabs,
   ])

  const teachersPrev = useRef<any>();

  const additionalFilter = useMemo(() => {
    return {
      page: currentPage,
      ...(noPresentation && { excludeProjectTypes: PRESENTATION_VIEW_TYPES })
    }
  }, [currentPage ]);
  const projectsRequest = useMemo(() => ({ ...filter, ...additionalFilter }), [filter, additionalFilter]);

  const tExtra = useMemo(() => date + temp, [date, temp]);

  const [projects, isProjectsLoading, , projectsPaging] = useProjectsList(
    projectsRequest,
    i18n.language,
    tExtra,
    isInfinityNeed,
    isTeamProjects,
    withOtherProjects,
    isLoading,
    useListLiteModal
  );

  useEffect(() => {
    if (showCompetitionJuryPoint || infinityProjectsFilter?.initJuryVote !== filter?.initJuryVote) {
      setTemp(Date.now())
    }
  }, [filter.onlyWithoutJuryVotes, filter.initJuryVote, showCompetitionJuryPoint, infinityProjectsFilter])

  const [fastScrolling, setFastScrolling] = useFastScrolling(infScrollRef?.current);

  useEffect(() => () => clearProjects && clearProjects(), [clearProjects]);

  useEffect(() => {
    if (!isStartPage && refresh) {
      dispatch(dispatch(InfinityProjectsActions.setIsNeedShowPreload(false)))
    }
    if (isBackToStartPage) {
      dispatch(dispatch(InfinityProjectsActions.setIsNeedShowPreload(true)))
    }
  }, [isStartPage, refresh, dispatch, isBackToStartPage])

  useEffect(() => {
    //@ts-ignore
    const stringData = JSON.stringify(isInfinityNeed ? infinityProjectsWithPreload : projects?.data)

    if(!prevStringData || prevStringData !== stringData) {
      setPrevStringData(stringData)
      //@ts-ignore
      onProjectsLoaded(isInfinityNeed ? infinityProjectsWithPreload : projects?.data);
      // setTimeout(() => isLoading && isLoading(false) , 1000)
    }
    if (setProjectCount) {
      //@ts-ignore
      isInfinityNeed ? setProjectCount(infinityProjectsWithPreload?.length) : setProjectCount(projectsPaging?.count);
    }
  }, [projects, infinityProjects, infinityProjectsWithPreload, isInfinityNeed, onProjectsLoaded, isLoading, prevStringData, projectsPaging, setProjectCount, i18n.language]);

  //@ts-ignore
  const showInfinityScroll = useMemo(() => (isInfinityNeed && infinityProjectsWithPreload && infinityProjectsWithPreload?.length > 0), [isInfinityNeed, infinityProjectsWithPreload])

  const needAutoFetchProjectsMore = useMemo(() => (Number(currentPage) > (isMobile ? PAGE_WHICH_UPLOAD_ENDS_MOB : PAGE_WHICH_UPLOAD_ENDS)), [currentPage, isMobile]);

  const isCanLoadInfinityProjectsMore = useMemo(() => {
    return isFinalPage || isOnlines;
  } , [infinityProjectsPaging, currentPage, isFinalPage])

  const filterChanged = useMemo(() => (
    !isProjectPage && (
      JSON.stringify(filter?.requestContext) !== JSON.stringify(infinityProjectsFilter?.requestContext) ||
      JSON.stringify(filter?.requiredTagIds) !== JSON.stringify(infinityProjectsFilter?.requiredTagIds) ||
      JSON.stringify(filter?.tagIds) !== JSON.stringify(infinityProjectsFilter?.tagIds) ||
      JSON.stringify(filter?.contexts) !== JSON.stringify(infinityProjectsFilter?.contexts) ||
      JSON.stringify(filter?.globalTypes) !== JSON.stringify(infinityProjectsFilter?.globalTypes) ||
      JSON.stringify(filter?.globalTypes) !== JSON.stringify(infinityProjectsFilter?.globalTypes) ||
      infinityProjectsFilter?.initJuryVote !== filter?.initJuryVote ||
      infinityProjectsFilter?.onlyWithoutJuryVotes !== filter?.onlyWithoutJuryVotes ||
      filter?.projectFilter !== infinityProjectsFilter?.projectFilter
      )
    ), [infinityProjectsFilter, filter, isProjectPage])


  const isPrevFiltersNotEquals  = useMemo(() => {
    if (isProjectPage) {
      return (
        JSON.stringify(filter?.requestContext) !== JSON.stringify(infinityProjectsFilter?.requestContext) ||
        JSON.stringify(filter?.requiredTagIds) !== JSON.stringify(infinityProjectsFilter?.requiredTagIds) ||
        JSON.stringify(filter?.tagIds) !== JSON.stringify(infinityProjectsFilter?.tagIds) ||
        JSON.stringify(filter?.contexts) !== JSON.stringify(infinityProjectsFilter?.contexts) ||
        JSON.stringify(filter?.globalTypes) !== JSON.stringify(infinityProjectsFilter?.globalTypes) ||
        JSON.stringify(filter?.initJuryVote) !== JSON.stringify(infinityProjectsFilter?.initJuryVote) ||
        JSON.stringify(filter?.onlyWithoutJuryVotes) !== JSON.stringify(infinityProjectsFilter?.onlyWithoutJuryVotes) ||
        filter?.projectFilter !== infinityProjectsFilter?.projectFilter
      )
    }
  }, [infinityProjectsFilter, filter, isProjectPage])


  const isInitialNeeded = useMemo(() => (
    !isProjectPage && (
      isFilterChanged( filter, infinityProjectsFilter, 'contexts') ||
      isFilterChanged(filter, infinityProjectsFilter, 'globalTypes') ||
      filter?.requestContext !== infinityProjectsFilter?.requestContext ||
      isFilterChanged(filter, infinityProjectsFilter, 'requiredTagIds') ||
      infinityProjectsFilter?.initJuryVote !== filter?.initJuryVote ||
      infinityProjectsFilter?.onlyWithoutJuryVotes !== filter?.onlyWithoutJuryVotes ||
      infinityProjectsFilter?.projectFilter !== filter?.projectFilter )
    ), [infinityProjectsFilter, filter, isProjectPage])

  const wasSelectedRef = useRef(false);
  const savedPageRef = useRef<number | null>(null);

  useEffect(() => {
    if (withoutQueryParams) return;

    const isSelected = !!filter?.projectIds?.length;
    const page = Number(currentPage) || 1;

    if (isSelected === wasSelectedRef.current) return;
    wasSelectedRef.current = isSelected;

    if (isSelected) {
      savedPageRef.current = page;
      if (page !== 1) setQueryParams({ page: 1 }, { replace: true });
      return;
    }

    const saved = savedPageRef.current;
    savedPageRef.current = null;
    if (saved && saved > 1 && page === 1) setQueryParams({ page: saved }, { replace: true });
  }, [filter?.projectIds, currentPage, withoutQueryParams, setQueryParams]);

  useEffect(() => {
    setFilterType(filter?.projectFilter);
    if (filterChanged) {
      if (!withoutQueryParams) setQueryParams({ page: 1 }, { replace: true })
      if (!isOnlines) {
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.clearOffset()); //Убрать если будут проблемы
      }
      dispatch(InfinityProjectsActions.setFilter(filter));
    }
    if (isPrevFiltersNotEquals) {
      dispatch(InfinityProjectsActions.setIsProjectPage(false));
    }
    if (!disableFilterCheck) {
      setTemp(Date.now());
    }
  }, [filter, dispatch, i18n, filterChanged, currentTab, isPrevFiltersNotEquals, setQueryParams, withoutQueryParams])

    useEffect(() => {
      if (!isPreloadLoading && (currentTab || "") in (infinityProjectsPagingList || {})) {
        dispatch(InfinityProjectsActions.setPaging(infinityProjectsPagingList[currentTab]));
      } else if (tabRef?.current !== currentTab) {
        dispatch(InfinityProjectsActions.clearFinalPage());
      }
      tabRef.current = currentTab
    }, [currentTab, tabRef, isPreloadLoading, infinityProjectsPagingList])
  
    useEffect(() => {
      return () => {
        dispatch(InfinityProjectsActions.clearFinalPage());
      }
    }, [])

  useEffect(() => {
    if (isInfinityNeed && isPageWithoutTabs && !isProjectPage) {
      if (isNeedUpdMore || isNeedUpdatePreload) {
        scrollTop();
        setRefresh(false)
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.setIsProjectPage(true));
        dispatch(
          fetchInfiniteProjectsWithUpdate(
            {
              page: isBackToStartPage ? NULLABLE_OFFSET : currentPage,
            }
          )
        );
        return;
      }
      if ((isStartPage || isBackToStartPage) && !(isOnlines && infinityProjects?.length)) {
        dispatch(
          fetchInfiniteProjectsMore(
            {
              page: isBackToStartPage ? NULLABLE_OFFSET : currentPage,
              exceptions: true ,
              tabs: preloadedTabs,
              contextName,
              withoutTabs: isPageWithoutTabs
            }
          )
        );
      }
    }

    if (isInfinityNeed && preloadedTabs && !isPageWithoutTabs) {
      if (isNeedUpdMore) {
        scrollTop();
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.setIsProjectPage(true));
        dispatch(
          fetchInfiniteProjectsWithUpdate(
            {
              page: currentPage,
            }
          )
        );
      }
      if (isInitialNeeded || isBackToStartPage) {
        setRefresh(false);
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.clearPreloadProjects());
        dispatch(fetchInfiniteProjects({
          preload: preloadedTabs,
          page: currentPage,
          currentTab,
        }));
        return;
      }
    }
  }, [
    isInitialNeeded,
    isNeedUpdMore,
    isStartPage,
    isBackToStartPage,
    isNeedUpdatePreload,
    dispatch,
    refresh,
    isProjectPage,
    currentPage,
    i18n,
    preloadedTabs,
    isInfinityNeed,
    isPageWithoutTabs,
    contextName
  ])

  useEffect(() => {

    if (!isProjectPage && currentTab && !isOnlines) {
      dispatch(InfinityProjectsActions.setIsProjectPage(false));
      dispatch(InfinityProjectsActions.clearProjects());
      dispatch(InfinityProjectsActions.clearOffset());
    }
  }, [dispatch, currentTab, isProjectPage])

  const setCurrentPage = (page: any) => setQueryParams({ page }, { replace: true });

  useEffect(() => {
    if (
      (!teachersOnly && teachersPrev.current) || (teachersPrev.current && !teachersOnly)
    ) {
      setCurrentPage(1);
      dispatch(InfinityProjectsActions.clear())
      setFastScrolling(false);
    }
    teachersPrev.current = teachersOnly;
  }, [
    teachersOnly,
    dispatch,
    setCurrentPage,
    setFastScrolling
  ])

  const isAlreadyProject = useCallback((data: string | undefined) => {
    if  (isParticipate && isParticipate.length > 0) {
      return data ? isParticipate.includes(data) : false;
    }
  }, [isParticipate])

  const fetchMoreProjects = useCallback(() => {
    setCurrentPage(((
      //@ts-ignore
      infinityProjectsPaging?.offset + PROJECTS_COUNT_FOR_OFFSET) / PROJECTS_COUNT_FOR_OFFSET)
    );
    dispatch(fetchInfiniteProjectsMore({
    }));
    if (!isPageWithoutTabs) {
      setRefresh(false)
    }
  }, [
    setCurrentPage,
    dispatch,
    infinityProjectsPaging,
    i18n,
    isPageWithoutTabs
  ])

  const fetchMoreProjectsNext= useCallback(() => {
      setCurrentPage(!infinityProjectsPaging.offset ? 2 : infinityProjectsPaging.offset === 20 ? 3 : ((
        //@ts-ignore
        infinityProjectsPaging.offset + PROJECTS_COUNT_FOR_OFFSET) / PROJECTS_COUNT_FOR_OFFSET) + PAGE_COUNT_STARTS
      );

      if (!isPageWithoutTabs) {
        setRefresh(false)
      }

      dispatch(fetchInfiniteProjectsMore({
        tabs: preloadedTabs,
        contextName,
        withoutTabs: isPageWithoutTabs
      }));
  }, [
    infinityProjectsPaging,
    setCurrentPage,
    i18n,
    dispatch,
    isPageWithoutTabs,
    preloadedTabs,
    contextName
  ])

  const ShowMoreButtonOrLoading = useMemo(() => {

    if (!infinityProjectsLoading) {
      return null;
    }

    return (
      <FlexBox direction='column' directionMobile='column'>
        <GridWrapperNew mobileColumns={2}>
          {new Array(8).fill('').map((_, index) => (
              <SkeletonCard key={index}/>
          ))}
        </GridWrapperNew>
        <FlexBox justify="center" offsetBottom={24} offsetTop={32}>
          <ProgressBar
            text={t('text.loading')}
            loading={true}
            color={theme.progressbar.color}
          />
        </FlexBox>
      </FlexBox>
    )
  }, [t, theme, infinityProjectsLoading])


  const paging = useMemo(() => {
      return isInfinityNeed ? infinityProjectsPaging : projects?.paging
  }, [isInfinityNeed, infinityProjectsPaging, projects]);

  const sortedProjects = useMemo(() => {
    const data = isOnlines
      ? [...(projects?.data ?? [])].sort((a, b) => {
        if (ONLINES_PROJECT_ORDER_INDEX[a.projectId] > ONLINES_PROJECT_ORDER_INDEX[b.projectId]) {
          return 1;
        }
        if (ONLINES_PROJECT_ORDER_INDEX[a.projectId] < ONLINES_PROJECT_ORDER_INDEX[b.projectId]) {
          return -1;
        }
        return 0;
      })
      : projects?.data;

    if (!data?.length) {
      return data;
    }

    const seen = new Set<string>();
    return data.filter((project) => {
      const id = project?.projectId;
      if (!id || seen.has(id)) {
        return false;
      }
      seen.add(id);
      return true;
    });
  }, [isOnlines, projects]);

  const localizedInfinityProjectsWithPreload = useMemo(() => {
    return infinityProjectsWithPreload ? API.toLang(infinityProjectsWithPreload, i18n.language) : []
  }, [infinityProjectsWithPreload, i18n.language])

  const showEmptyTabMsg = useMemo(
    () => 
    isDafes &&
    !isProjectsLoading && 
    !isPreloadLoading && 
    !localizedInfinityProjectsWithPreload?.length, 
    [
      localizedInfinityProjectsWithPreload,
      isProjectsLoading,
      isPreloadLoading,
      isDafes
  ])

  return (
    <FlexBox direction="column" directionMobile="column" gy={40} flex="1">
      {!showInfinityScroll && (
        <ProjectsGridNew k={isMainPage ? 20 : undefined} isLoading={isProjectsLoading || isPreloadLoading} columns={columns} isAgeytomesh={isAgeyTomesh} itemType={itemType}>
        {sortedProjects?.map((v: Nullable<Partial<Project<'Local'>>>) => (
          <ProjectCardItem
            key={v?.projectId}
            project={v}
            selectable={selectable}
            unselectable={unselectable}
            selected={selectedProjects?.includes(v?.projectId ?? '')}
            onSelect={onSelect}
            modal={modal}
            withoutGoToProject={withoutGoToProject}
            withoutRepost={withoutRepost}
            linkPrefix={linkPrefix}
            isMoreVisible={isMoreVisible}
            isSelectRightNeed={isSelectRightNeed}
            selectRingPosition={selectRingPosition}
            itemType={itemType}
            metaAlwaysVisible={selectedProjects?.includes(v?.projectId ?? '') || metaAlwaysVisible}
            alreadyProject={isAlreadyProject(v?.projectId)}
            showCompetitionPoint={showCompetitionPoint}
            showCompetitionJuryPoint={showCompetitionJuryPoint}
            showFirstCompetitionPoint={showFirstCompetitionPoint}
            currentCompetitionId={currentCompetitionId}
            canMakeImageForTeam={canMakeImageForTeam}
            noPresentation={noPresentation}
            competition={competition}
            onShouldReload={() => setTemp(Date.now())}
          />
        ))}
      </ProjectsGridNew>
      )}

      {showInfinityScroll && (
        <InfiniteScroll
        //@ts-ignore
            dataLength={localizedInfinityProjectsWithPreload?.length}
            next={fetchMoreProjectsNext}
            hasMore={!isCanLoadInfinityProjectsMore}
            initialScrollY={0}
            scrollThreshold={0.9}
            loader={ShowMoreButtonOrLoading}
            ref={infScrollRef}
          >
            <ProjectsGridNew k={isMainPage ? 20 : undefined} isLoading={isProjectsLoading || isPreloadLoading} columns={columns} isAgeytomesh={isAgeyTomesh}>
              {/*@ts-ignore*/}
              {localizedInfinityProjectsWithPreload?.map((v: Nullable<Partial<Project<'Local'>>>) => (
                <ProjectCardItem
                  key={v?.projectId}
                  project={v}
                  selectable={selectable}
                  unselectable={unselectable}
                  selected={selectedProjects?.includes(v?.projectId ?? '')}
                  onSelect={onSelect}
                  modal={modal}
                  withoutGoToProject={withoutGoToProject}
                  withoutRepost={withoutRepost}
                  linkPrefix={linkPrefix}
                  isMoreVisible={isMoreVisible}
                  isSelectRightNeed={isSelectRightNeed}
                  selectRingPosition={selectRingPosition}
                  itemType={itemType}
                  metaAlwaysVisible={selectedProjects?.includes(v?.projectId ?? '') || metaAlwaysVisible}
                  alreadyProject={isAlreadyProject(v?.projectId)}
                  showCompetitionPoint={showCompetitionPoint}
                  showCompetitionJuryPoint={showCompetitionJuryPoint}
                  showFirstCompetitionPoint={showFirstCompetitionPoint}
                  currentCompetitionId={currentCompetitionId}
                  canMakeImageForTeam={canMakeImageForTeam}
                  noPresentation={noPresentation}
                  competition={competition}
                  onShouldReload={() => setTemp(Date.now())}
                />
              ))}
            </ProjectsGridNew>
        </InfiniteScroll>
      )}
      {isInfinityNeed && !isPageWithoutTabs && (
          <EmptyCardsLoading k={isMainPage ? 0 : 8} isLoading={isProjectsLoading || isPreloadLoading} />
      )}
      {!isInfinityNeed && (
        <Pagination
          pages={paging?.pages ?? 0}
          page={Number(currentPage)}
          onPageChange={(page) => {
            setQueryParams({ page }, { replace: true });
            isInfinityNeed && setRefresh(true)
            isPageWithoutTabs && dispatch(
              InfinityProjectsActions.setIsProjectPage(false)
            );
            setTemp(Date.now());
            scrollTop();
          }}
          isCanLoadMore={currentPage < (paging?.pages ?? 0)}
          hidden={(!paging?.pages || paging?.pages === 1)}
        />
      )}
      {showEmptyTabMsg && <EmptyCategory />}
     {!noPagging && <OffsetBlock display={(!paging?.pages || paging?.pages === 1)} />}
    </FlexBox>
  );
});
// @ts-nocheck
import React, { FC, useEffect, useState, useMemo, memo, useCallback, useRef } from 'react';
import {Nullable, Project, PageModel, API, GetProjectsByFilterProps, Competition} from '@brg/api';
import { useProfile, bProfile } from '@brg/auth';
import { FInter, FlexBox, useIsMobile, useScrollingState } from '@brg/ui';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector, useDispatch } from "react-redux";
import { GridWrapperNew, ProjectsGridNew } from '../../shared/components/grids';
import { useProjectsList } from '../../shared/hooks/api/useProjectsByFilter';
import { Pagination } from '../../shared/components/pagination';
import { useModal } from '../modules';
import useQueryState from "../../shared/hooks/useQueryState";
import { useTranslation } from 'react-i18next';
import { ProgressBar } from 'shared/icons/Progress';
import styled, { useTheme } from 'styled-components';
import { useFastScrolling } from 'shared/hooks/useFastScrolling';
import { AppTester } from "supporting";
import { InfinityProjectsSelector, InfinityProjectsActions } from '../../shared/reducers/InfinityProjects';
import ShowMoreProjectsBlock from 'shared/components/ShowMoreProjectsBlock/ShowMoreProjectsBlock';

import {
  fetchInfiniteProjects,
  fetchInfiniteProjectsMore,
  fetchInfiniteProjectsWithUpdate
} from '../../shared/actions/infinityProjectsActions';
import { EmptyCardsLoading } from 'shared/components/CardsLoading/EmptyCards';
import { SkeletonCard } from 'shared/components/SkeletonCard/SkeletonCard';
import { ONLINES_PROJECT_ORDER_INDEX } from "../../shared/pages/explore/constants";
import { useLocation, useRouteMatch } from "react-router-dom";
import { TOwnerRights } from 'shared/pages/exploreHseContextsNew/exploreHseContextsNew';
import { PRESENTATION_VIEW_TYPES } from 'shared/constants/presentationSign';
import { RingPositions } from 'shared/constants/ringPositionType';
import { EmptyCategory } from 'shared/components/EmptyCategory/EmptyCategory';
import { ProjectCardItem } from './ProjectsButchController/ProjectCardItem';

const PROJECTS_COUNT_FOR_OFFSET = 20;
const PAGE_COUNT_STARTS = 1;
const PAGE_WHICH_UPLOAD_ENDS = 4;
const PAGE_WHICH_UPLOAD_ENDS_MOB = 3;
const NULLABLE_OFFSET = 0;

export const StyledLoading = styled.div`
    margin-bottom: 40px;
    padding: 10px;
    font-size: 60px;
    line-height: 1;
    color: white;
    text-align: center;
`;

export const ShowMoreWrapper = styled(FlexBox)`
  margin-left: auto;
  margin-right: auto;
  border: 1px solid ${p => p.theme.progressbar.borderColor};
  border-radius: 3px;
  padding: 12px 48px;
`;

const OffsetBlock = styled.div<{ display: boolean }>`
  width: 100%;
  margin-top: 64px;
  display: ${p => p?.display ? 'inline-block' : 'none'};
`;

const isFilterChanged = (v: any, k: any, entity: string) => {
  return v && k && v[entity] && (k[entity] === undefined || (k[entity] && v[entity][0] !== k[entity][0]))
}

type Tabs = {
  [key: string]: string[] | string | null;
}

/**
 * @param withOtherProjects - сделать запрос в модалке своих и чужих проектов для папок
 */

export interface ProjectsButchControllerProps<T = Project> {
  filter: GetProjectsByFilterProps;
  date: number;
  onProjectsLoaded?: (projects: T[]) => void;
  setProjectsLoadingExt?: (isLoadiing?: boolean) => void
  selectable?: boolean;
  unselectable?: boolean;
  onSelect?: (projectId: string) => void;
  withoutGoToProject?: boolean;
  noPagging?: boolean;
  selectedProjects?: string[];
  isParticipate?: string[];
  modal?: boolean;
  clearProjects?: () => void,
  setProjectCount?: (count: any) => void,
  linkPrefix?: string;
  isInfinityNeed?: boolean;
  projectsCount?: number;
  isLoading?: Function;
  isSelectRightNeed?:boolean;
  columns?: number;
  isUnload?: boolean;
  preloadedTabs?: Tabs[];
  currentTab?: string;
  contextName?: string;
  isPageWithoutTabs?: boolean;
  disableFilterCheck?: boolean;
  showCompetitionPoint?: boolean;
  showCompetitionJuryPoint?: boolean;
  showFirstCompetitionPoint?: boolean;
  currentCompetitionId?: string;
  isTeamProjects?: boolean;
  withoutQueryParams?: boolean;
  isDisabled?: boolean;
  canMakeImageForTeam?: TOwnerRights;
  externalPageParam?: boolean;
  isMainPage?: boolean;
  metaAlwaysVisible?: boolean;
  itemType?: string;
  noPresentation?: boolean;
  selectRingPosition?: RingPositions;
  isMoreVisible?: boolean;
  withOtherProjects?: boolean;
  useListLiteModal?: boolean;
  withoutRepost?: boolean;
  competition?: Competition<'Local'>;
}

export const ProjectsButchController: FC<ProjectsButchControllerProps> = memo(({
  filter,
  date,
  onProjectsLoaded = () => undefined,
  setProjectsLoadingExt,
  isLoading,
  selectable = false,
  modal = false,
  onSelect = () => undefined,
  withoutGoToProject,
  withOtherProjects,
  noPagging,
  selectedProjects = [],
  isParticipate = [],
  clearProjects,
  setProjectCount,
  withoutRepost,
  projectsCount,
  isMoreVisible,
  linkPrefix,
  isInfinityNeed,
  isSelectRightNeed,
  selectRingPosition,
  unselectable,
  columns,
  isUnload,
  isPageWithoutTabs,
  preloadedTabs,
  contextName,
  currentTab,
  disableFilterCheck,
  showCompetitionPoint,
  showCompetitionJuryPoint,
  showFirstCompetitionPoint,
  currentCompetitionId,
  isTeamProjects,
  canMakeImageForTeam,
  withoutQueryParams,
  externalPageParam,
  noPresentation,
  isMainPage,
  itemType,
  metaAlwaysVisible,
  competition,
  useListLiteModal
}) => {
  const designer = useProfile();
  const theme = useTheme();
  const [{ page: externalPage = 1, teachersOnly },  setExternalQueryParams] = useQueryState();
  const [temp, setTemp] = useState(0);
  const dispatch = useDispatch();
  const [prevStringData, setPrevStringData] = useState('');
  const [filterType, setFilterType] = useState<number>();
  const { show } = useModal();
  const [refresh, setRefresh] = useState<boolean>(false);
  const isAgeyTomesh = AppTester.isAgeytomesh();
  const isOnlines = AppTester.isOnlines();
  const isMobile = useIsMobile();
  const isDafes = AppTester.isGeoDafes();

  const [internalPage, setPage] = useState(1);

  const currentPage = externalPageParam ? externalPage : internalPage;

  const setQueryParams = useCallback(({ page }: any) => {
    if (externalPageParam) {
      setExternalQueryParams({ page }, { replace: true })
    } else {
      setPage(page);
    }
  }, [externalPageParam]);

  const { t, i18n } = useTranslation();

  const infScrollRef = useRef<any>(null);
  const tabRef = useRef<any>(null);
  const scrollTop = () => window.scrollTo(0 , 0);

  const infinityProjects = useSelector(InfinityProjectsSelector)?.data;
  const infinityProjectsPaging = useSelector(InfinityProjectsSelector)?.paging;
  const infinityProjectsFilter= useSelector(InfinityProjectsSelector)?.filter;
  const infinityProjectsPreloadData = useSelector(InfinityProjectsSelector)?.preloadData;
  const infinityProjectsPagingList = useSelector(InfinityProjectsSelector)?.pagingList;
  const isPreloadLoading = useSelector(InfinityProjectsSelector)?.isTabsLoading;
  const isProjectPage = useSelector(InfinityProjectsSelector)?.isProjectPage;
  const infinityProjectsLoading = useSelector(InfinityProjectsSelector)?.isLoading;
  const isFinalPage = useSelector(InfinityProjectsSelector)?.isFinalPage;


  const isStartPage = useMemo(() => (currentPage && Number(currentPage) === PAGE_COUNT_STARTS), [currentPage])
  const isNeedUpdatePreload = useMemo(
    () => ( refresh && Number(currentPage) === PAGE_COUNT_STARTS), [refresh, currentPage]);
  const isNeedUpdMore = useMemo(
    () => ( refresh && Number(currentPage) > PAGE_COUNT_STARTS), [refresh, currentPage])
  const isBackToStartPage = useMemo(() => (refresh && Number(currentPage) === PAGE_COUNT_STARTS), [refresh, currentPage]);

  const infinityProjectsWithPreload = useMemo(() => {
    if (isOnlines) {
      return [...infinityProjects]?.sort((a, b) => {
        if (ONLINES_PROJECT_ORDER_INDEX[a.projectId] > ONLINES_PROJECT_ORDER_INDEX[b.projectId]) {
          return 1;
        }
        if (ONLINES_PROJECT_ORDER_INDEX[a.projectId] < ONLINES_PROJECT_ORDER_INDEX[b.projectId]) {
          return -1;
        }
        return 0;
      });
    }
    if (isPageWithoutTabs || (isPageWithoutTabs && (isNeedUpdMore || isBackToStartPage))) {
      return infinityProjects;
    }
    if (currentTab && !isPreloadLoading) {
      const arr = infinityProjectsPreloadData[currentTab] ? infinityProjectsPreloadData[currentTab] : [];
        if (isStartPage || isNeedUpdatePreload || isBackToStartPage) return arr;
        if (isNeedUpdMore) return infinityProjects;
        else {
          return [...arr, ...infinityProjects]
        }
    }
  }, [
    infinityProjects,
    infinityProjectsPreloadData,
    currentTab,
    isNeedUpdMore,
    // isNeedShowPreload,
    isPreloadLoading,
    isNeedUpdatePreload,
    isStartPage,
    isBackToStartPage,
    isPageWithoutTabs,
   ])

  const teachersPrev = useRef<any>();

  const additionalFilter = useMemo(() => {
    return {
      page: currentPage,
      ...(noPresentation && { excludeProjectTypes: PRESENTATION_VIEW_TYPES })
    }
  }, [currentPage ]);
  const projectsRequest = useMemo(() => ({ ...filter, ...additionalFilter }), [filter, additionalFilter]);

  const tExtra = useMemo(() => date + temp, [date, temp]);

  const [projects, isProjectsLoading, , projectsPaging] = useProjectsList(
    projectsRequest,
    i18n.language,
    tExtra,
    isInfinityNeed,
    isTeamProjects,
    withOtherProjects,
    isLoading,
    useListLiteModal
  );

  useEffect(() => {
    if (showCompetitionJuryPoint || infinityProjectsFilter?.initJuryVote !== filter?.initJuryVote) {
      setTemp(Date.now())
    }
  }, [filter.onlyWithoutJuryVotes, filter.initJuryVote, showCompetitionJuryPoint, infinityProjectsFilter])

  const [fastScrolling, setFastScrolling] = useFastScrolling(infScrollRef?.current);

  useEffect(() => () => clearProjects && clearProjects(), [clearProjects]);

  useEffect(() => {
    if (!isStartPage && refresh) {
      dispatch(dispatch(InfinityProjectsActions.setIsNeedShowPreload(false)))
    }
    if (isBackToStartPage) {
      dispatch(dispatch(InfinityProjectsActions.setIsNeedShowPreload(true)))
    }
  }, [isStartPage, refresh, dispatch, isBackToStartPage])

  useEffect(() => {
    //@ts-ignore
    const stringData = JSON.stringify(isInfinityNeed ? infinityProjectsWithPreload : projects?.data)

    if(!prevStringData || prevStringData !== stringData) {
      setPrevStringData(stringData)
      //@ts-ignore
      onProjectsLoaded(isInfinityNeed ? infinityProjectsWithPreload : projects?.data);
      // setTimeout(() => isLoading && isLoading(false) , 1000)
    }
    if (setProjectCount) {
      //@ts-ignore
      isInfinityNeed ? setProjectCount(infinityProjectsWithPreload?.length) : setProjectCount(projectsPaging?.count);
    }
  }, [projects, infinityProjects, infinityProjectsWithPreload, isInfinityNeed, onProjectsLoaded, isLoading, prevStringData, projectsPaging, setProjectCount, i18n.language]);

  //@ts-ignore
  const showInfinityScroll = useMemo(() => (isInfinityNeed && infinityProjectsWithPreload && infinityProjectsWithPreload?.length > 0), [isInfinityNeed, infinityProjectsWithPreload])

  const needAutoFetchProjectsMore = useMemo(() => (Number(currentPage) > (isMobile ? PAGE_WHICH_UPLOAD_ENDS_MOB : PAGE_WHICH_UPLOAD_ENDS)), [currentPage, isMobile]);

  const isCanLoadInfinityProjectsMore = useMemo(() => {
    return isFinalPage || isOnlines;
  } , [infinityProjectsPaging, currentPage, isFinalPage])

  const filterChanged = useMemo(() => (
    !isProjectPage && (
      JSON.stringify(filter?.requestContext) !== JSON.stringify(infinityProjectsFilter?.requestContext) ||
      JSON.stringify(filter?.requiredTagIds) !== JSON.stringify(infinityProjectsFilter?.requiredTagIds) ||
      JSON.stringify(filter?.tagIds) !== JSON.stringify(infinityProjectsFilter?.tagIds) ||
      JSON.stringify(filter?.contexts) !== JSON.stringify(infinityProjectsFilter?.contexts) ||
      JSON.stringify(filter?.globalTypes) !== JSON.stringify(infinityProjectsFilter?.globalTypes) ||
      JSON.stringify(filter?.globalTypes) !== JSON.stringify(infinityProjectsFilter?.globalTypes) ||
      infinityProjectsFilter?.initJuryVote !== filter?.initJuryVote ||
      infinityProjectsFilter?.onlyWithoutJuryVotes !== filter?.onlyWithoutJuryVotes ||
      filter?.projectFilter !== infinityProjectsFilter?.projectFilter
      )
    ), [infinityProjectsFilter, filter, isProjectPage])


  const isPrevFiltersNotEquals  = useMemo(() => {
    if (isProjectPage) {
      return (
        JSON.stringify(filter?.requestContext) !== JSON.stringify(infinityProjectsFilter?.requestContext) ||
        JSON.stringify(filter?.requiredTagIds) !== JSON.stringify(infinityProjectsFilter?.requiredTagIds) ||
        JSON.stringify(filter?.tagIds) !== JSON.stringify(infinityProjectsFilter?.tagIds) ||
        JSON.stringify(filter?.contexts) !== JSON.stringify(infinityProjectsFilter?.contexts) ||
        JSON.stringify(filter?.globalTypes) !== JSON.stringify(infinityProjectsFilter?.globalTypes) ||
        JSON.stringify(filter?.initJuryVote) !== JSON.stringify(infinityProjectsFilter?.initJuryVote) ||
        JSON.stringify(filter?.onlyWithoutJuryVotes) !== JSON.stringify(infinityProjectsFilter?.onlyWithoutJuryVotes) ||
        filter?.projectFilter !== infinityProjectsFilter?.projectFilter
      )
    }
  }, [infinityProjectsFilter, filter, isProjectPage])


  const isInitialNeeded = useMemo(() => (
    !isProjectPage && (
      isFilterChanged( filter, infinityProjectsFilter, 'contexts') ||
      isFilterChanged(filter, infinityProjectsFilter, 'globalTypes') ||
      filter?.requestContext !== infinityProjectsFilter?.requestContext ||
      isFilterChanged(filter, infinityProjectsFilter, 'requiredTagIds') ||
      infinityProjectsFilter?.initJuryVote !== filter?.initJuryVote ||
      infinityProjectsFilter?.onlyWithoutJuryVotes !== filter?.onlyWithoutJuryVotes ||
      infinityProjectsFilter?.projectFilter !== filter?.projectFilter )
    ), [infinityProjectsFilter, filter, isProjectPage])

  const wasSelectedRef = useRef(false);
  const savedPageRef = useRef<number | null>(null);

  useEffect(() => {
    if (withoutQueryParams) return;

    const isSelected = !!filter?.projectIds?.length;
    const page = Number(currentPage) || 1;

    if (isSelected === wasSelectedRef.current) return;
    wasSelectedRef.current = isSelected;

    if (isSelected) {
      savedPageRef.current = page;
      if (page !== 1) setQueryParams({ page: 1 }, { replace: true });
      return;
    }

    const saved = savedPageRef.current;
    savedPageRef.current = null;
    if (saved && saved > 1 && page === 1) setQueryParams({ page: saved }, { replace: true });
  }, [filter?.projectIds, currentPage, withoutQueryParams, setQueryParams]);

  useEffect(() => {
    setFilterType(filter?.projectFilter);
    if (filterChanged) {
      if (!withoutQueryParams) setQueryParams({ page: 1 }, { replace: true })
      if (!isOnlines) {
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.clearOffset()); //Убрать если будут проблемы
      }
      dispatch(InfinityProjectsActions.setFilter(filter));
    }
    if (isPrevFiltersNotEquals) {
      dispatch(InfinityProjectsActions.setIsProjectPage(false));
    }
    if (!disableFilterCheck) {
      setTemp(Date.now());
    }
  }, [filter, dispatch, i18n, filterChanged, currentTab, isPrevFiltersNotEquals, setQueryParams, withoutQueryParams])

    useEffect(() => {
      if (!isPreloadLoading && (currentTab || "") in (infinityProjectsPagingList || {})) {
        dispatch(InfinityProjectsActions.setPaging(infinityProjectsPagingList[currentTab]));
      } else if (tabRef?.current !== currentTab) {
        dispatch(InfinityProjectsActions.clearFinalPage());
      }
      tabRef.current = currentTab
    }, [currentTab, tabRef, isPreloadLoading, infinityProjectsPagingList])
  
    useEffect(() => {
      return () => {
        dispatch(InfinityProjectsActions.clearFinalPage());
      }
    }, [])

  useEffect(() => {
    if (isInfinityNeed && isPageWithoutTabs && !isProjectPage) {
      if (isNeedUpdMore || isNeedUpdatePreload) {
        scrollTop();
        setRefresh(false)
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.setIsProjectPage(true));
        dispatch(
          fetchInfiniteProjectsWithUpdate(
            {
              page: isBackToStartPage ? NULLABLE_OFFSET : currentPage,
            }
          )
        );
        return;
      }
      if ((isStartPage || isBackToStartPage) && !(isOnlines && infinityProjects?.length)) {
        dispatch(
          fetchInfiniteProjectsMore(
            {
              page: isBackToStartPage ? NULLABLE_OFFSET : currentPage,
              exceptions: true ,
              tabs: preloadedTabs,
              contextName,
              withoutTabs: isPageWithoutTabs
            }
          )
        );
      }
    }

    if (isInfinityNeed && preloadedTabs && !isPageWithoutTabs) {
      if (isNeedUpdMore) {
        scrollTop();
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.setIsProjectPage(true));
        dispatch(
          fetchInfiniteProjectsWithUpdate(
            {
              page: currentPage,
            }
          )
        );
      }
      if (isInitialNeeded || isBackToStartPage) {
        setRefresh(false);
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.clearPreloadProjects());
        dispatch(fetchInfiniteProjects({
          preload: preloadedTabs,
          page: currentPage,
          currentTab,
        }));
        return;
      }
    }
  }, [
    isInitialNeeded,
    isNeedUpdMore,
    isStartPage,
    isBackToStartPage,
    isNeedUpdatePreload,
    dispatch,
    refresh,
    isProjectPage,
    currentPage,
    i18n,
    preloadedTabs,
    isInfinityNeed,
    isPageWithoutTabs,
    contextName
  ])

  useEffect(() => {

    if (!isProjectPage && currentTab && !isOnlines) {
      dispatch(InfinityProjectsActions.setIsProjectPage(false));
      dispatch(InfinityProjectsActions.clearProjects());
      dispatch(InfinityProjectsActions.clearOffset());
    }
  }, [dispatch, currentTab, isProjectPage])

  const setCurrentPage = (page: any) => setQueryParams({ page }, { replace: true });

  useEffect(() => {
    if (
      (!teachersOnly && teachersPrev.current) || (teachersPrev.current && !teachersOnly)
    ) {
      setCurrentPage(1);
      dispatch(InfinityProjectsActions.clear())
      setFastScrolling(false);
    }
    teachersPrev.current = teachersOnly;
  }, [
    teachersOnly,
    dispatch,
    setCurrentPage,
    setFastScrolling
  ])

  const isAlreadyProject = useCallback((data: string | undefined) => {
    if  (isParticipate && isParticipate.length > 0) {
      return data ? isParticipate.includes(data) : false;
    }
  }, [isParticipate])

  const fetchMoreProjects = useCallback(() => {
    setCurrentPage(((
      //@ts-ignore
      infinityProjectsPaging?.offset + PROJECTS_COUNT_FOR_OFFSET) / PROJECTS_COUNT_FOR_OFFSET)
    );
    dispatch(fetchInfiniteProjectsMore({
    }));
    if (!isPageWithoutTabs) {
      setRefresh(false)
    }
  }, [
    setCurrentPage,
    dispatch,
    infinityProjectsPaging,
    i18n,
    isPageWithoutTabs
  ])

  const fetchMoreProjectsNext= useCallback(() => {
      setCurrentPage(!infinityProjectsPaging.offset ? 2 : infinityProjectsPaging.offset === 20 ? 3 : ((
        //@ts-ignore
        infinityProjectsPaging.offset + PROJECTS_COUNT_FOR_OFFSET) / PROJECTS_COUNT_FOR_OFFSET) + PAGE_COUNT_STARTS
      );

      if (!isPageWithoutTabs) {
        setRefresh(false)
      }

      dispatch(fetchInfiniteProjectsMore({
        tabs: preloadedTabs,
        contextName,
        withoutTabs: isPageWithoutTabs
      }));
  }, [
    infinityProjectsPaging,
    setCurrentPage,
    i18n,
    dispatch,
    isPageWithoutTabs,
    preloadedTabs,
    contextName
  ])

  const ShowMoreButtonOrLoading = useMemo(() => {

    if (!infinityProjectsLoading) {
      return null;
    }

    return (
      <FlexBox direction='column' directionMobile='column'>
        <GridWrapperNew mobileColumns={2}>
          {new Array(8).fill('').map((_, index) => (
              <SkeletonCard key={index}/>
          ))}
        </GridWrapperNew>
        <FlexBox justify="center" offsetBottom={24} offsetTop={32}>
          <ProgressBar
            text={t('text.loading')}
            loading={true}
            color={theme.progressbar.color}
          />
        </FlexBox>
      </FlexBox>
    )
  }, [t, theme, infinityProjectsLoading])


  const paging = useMemo(() => {
      return isInfinityNeed ? infinityProjectsPaging : projects?.paging
  }, [isInfinityNeed, infinityProjectsPaging, projects]);

  const sortedProjects = useMemo(() => {
    const data = isOnlines
      ? [...(projects?.data ?? [])].sort((a, b) => {
        if (ONLINES_PROJECT_ORDER_INDEX[a.projectId] > ONLINES_PROJECT_ORDER_INDEX[b.projectId]) {
          return 1;
        }
        if (ONLINES_PROJECT_ORDER_INDEX[a.projectId] < ONLINES_PROJECT_ORDER_INDEX[b.projectId]) {
          return -1;
        }
        return 0;
      })
      : projects?.data;

    if (!data?.length) {
      return data;
    }

    const seen = new Set<string>();
    return data.filter((project) => {
      const id = project?.projectId;
      if (!id || seen.has(id)) {
        return false;
      }
      seen.add(id);
      return true;
    });
  }, [isOnlines, projects]);

  const localizedInfinityProjectsWithPreload = useMemo(() => {
    return infinityProjectsWithPreload ? API.toLang(infinityProjectsWithPreload, i18n.language) : []
  }, [infinityProjectsWithPreload, i18n.language])

  const showEmptyTabMsg = useMemo(
    () => 
    isDafes &&
    !isProjectsLoading && 
    !isPreloadLoading && 
    !localizedInfinityProjectsWithPreload?.length, 
    [
      localizedInfinityProjectsWithPreload,
      isProjectsLoading,
      isPreloadLoading,
      isDafes
  ])

  return (
    <FlexBox direction="column" directionMobile="column" gy={40} flex="1">
      {!showInfinityScroll && (
        <ProjectsGridNew k={isMainPage ? 20 : undefined} isLoading={isProjectsLoading || isPreloadLoading} columns={columns} isAgeytomesh={isAgeyTomesh} itemType={itemType}>
        {sortedProjects?.map((v: Nullable<Partial<Project<'Local'>>>) => (
          <ProjectCardItem
            key={v?.projectId}
            project={v}
            selectable={selectable}
            unselectable={unselectable}
            selected={selectedProjects?.includes(v?.projectId ?? '')}
            onSelect={onSelect}
            modal={modal}
            withoutGoToProject={withoutGoToProject}
            withoutRepost={withoutRepost}
            linkPrefix={linkPrefix}
            isMoreVisible={isMoreVisible}
            isSelectRightNeed={isSelectRightNeed}
            selectRingPosition={selectRingPosition}
            itemType={itemType}
            metaAlwaysVisible={selectedProjects?.includes(v?.projectId ?? '') || metaAlwaysVisible}
            alreadyProject={isAlreadyProject(v?.projectId)}
            showCompetitionPoint={showCompetitionPoint}
            showCompetitionJuryPoint={showCompetitionJuryPoint}
            showFirstCompetitionPoint={showFirstCompetitionPoint}
            currentCompetitionId={currentCompetitionId}
            canMakeImageForTeam={canMakeImageForTeam}
            noPresentation={noPresentation}
            competition={competition}
            onShouldReload={() => setTemp(Date.now())}
          />
        ))}
      </ProjectsGridNew>
      )}

      {showInfinityScroll && (
        <InfiniteScroll
        //@ts-ignore
            dataLength={localizedInfinityProjectsWithPreload?.length}
            next={fetchMoreProjectsNext}
            hasMore={!isCanLoadInfinityProjectsMore}
            initialScrollY={0}
            scrollThreshold={0.9}
            loader={ShowMoreButtonOrLoading}
            ref={infScrollRef}
          >
            <ProjectsGridNew k={isMainPage ? 20 : undefined} isLoading={isProjectsLoading || isPreloadLoading} columns={columns} isAgeytomesh={isAgeyTomesh}>
              {/*@ts-ignore*/}
              {localizedInfinityProjectsWithPreload?.map((v: Nullable<Partial<Project<'Local'>>>) => (
                <ProjectCardItem
                  key={v?.projectId}
                  project={v}
                  selectable={selectable}
                  unselectable={unselectable}
                  selected={selectedProjects?.includes(v?.projectId ?? '')}
                  onSelect={onSelect}
                  modal={modal}
                  withoutGoToProject={withoutGoToProject}
                  withoutRepost={withoutRepost}
                  linkPrefix={linkPrefix}
                  isMoreVisible={isMoreVisible}
                  isSelectRightNeed={isSelectRightNeed}
                  selectRingPosition={selectRingPosition}
                  itemType={itemType}
                  metaAlwaysVisible={selectedProjects?.includes(v?.projectId ?? '') || metaAlwaysVisible}
                  alreadyProject={isAlreadyProject(v?.projectId)}
                  showCompetitionPoint={showCompetitionPoint}
                  showCompetitionJuryPoint={showCompetitionJuryPoint}
                  showFirstCompetitionPoint={showFirstCompetitionPoint}
                  currentCompetitionId={currentCompetitionId}
                  canMakeImageForTeam={canMakeImageForTeam}
                  noPresentation={noPresentation}
                  competition={competition}
                  onShouldReload={() => setTemp(Date.now())}
                />
              ))}
            </ProjectsGridNew>
        </InfiniteScroll>
      )}
      {isInfinityNeed && !isPageWithoutTabs && (
          <EmptyCardsLoading k={isMainPage ? 0 : 8} isLoading={isProjectsLoading || isPreloadLoading} />
      )}
      {!isInfinityNeed && (
        <Pagination
          pages={paging?.pages ?? 0}
          page={Number(currentPage)}
          onPageChange={(page) => {
            setQueryParams({ page }, { replace: true });
            isInfinityNeed && setRefresh(true)
            isPageWithoutTabs && dispatch(
              InfinityProjectsActions.setIsProjectPage(false)
            );
            setTemp(Date.now());
            scrollTop();
          }}
          isCanLoadMore={currentPage < (paging?.pages ?? 0)}
          hidden={(!paging?.pages || paging?.pages === 1)}
        />
      )}
      {showEmptyTabMsg && <EmptyCategory />}
     {!noPagging && <OffsetBlock display={(!paging?.pages || paging?.pages === 1)} />}
    </FlexBox>
  );
});
